(function () {
  function revealImage(img) {
    if (!img || !img.dataset.src) return;
    img.src = img.dataset.src;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.sizes) img.sizes = img.dataset.sizes;
    delete img.dataset.src;
    delete img.dataset.srcset;
    img.classList.remove('pcs-lazy');
  }

  function preloadSlide(slides, index) {
    var slide = slides[index];
    if (!slide) return;
    revealImage(slide.querySelector('.pcs-lazy'));
  }

  function initSwipe(wrap) {
    if (wrap._pcsInit) return;
    wrap._pcsInit = true;

    var track = wrap.querySelector('[data-pcs-track]');
    var dots = wrap.querySelectorAll('.pcs-dot');
    if (!track) return;

    var slides = track.querySelectorAll('.pcs-slide');
    if (slides.length <= 1) return;

    var currentIndex = 0;
    var startX = 0;
    var isDragging = false;
    var didSwipe = false;
    var THRESHOLD = 35;

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
      // Reveal current and preload next
      preloadSlide(slides, currentIndex);
      preloadSlide(slides, currentIndex + 1);
    }

    // Touch
    wrap.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isDragging = true;
      didSwipe = false;
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > THRESHOLD) {
        didSwipe = true;
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });

    // Mouse
    wrap.addEventListener('mousedown', function (e) {
      startX = e.clientX;
      isDragging = true;
      didSwipe = false;
    });

    wrap.addEventListener('mouseup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - e.clientX;
      if (Math.abs(diff) > THRESHOLD) {
        didSwipe = true;
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    });

    // Prevent link navigation when swiped
    var link = wrap.closest('a');
    if (link) {
      link.addEventListener('click', function (e) {
        if (didSwipe) {
          e.preventDefault();
          didSwipe = false;
        }
      });
    }

    // Arrows — Mango style: clickable, hover on desktop, brief flash on mobile
    // Place arrows on the figure parent (outside <a> link) so clicks don't navigate
    var figureEl = wrap.closest('.product-card__figure, .ed-card__figure, .duo-card__figure, .duo-hero__figure, .outlet-card, [class*="card__figure"]') || wrap.parentElement;

    var arrowLeft = document.createElement('div');
    arrowLeft.className = 'pcs-arrow pcs-arrow--left';
    arrowLeft.innerHTML = '<svg viewBox="0 0 12 12"><polyline points="8 2 4 6 8 10"/></svg>';

    var arrowRight = document.createElement('div');
    arrowRight.className = 'pcs-arrow pcs-arrow--right';
    arrowRight.innerHTML = '<svg viewBox="0 0 12 12"><polyline points="4 2 8 6 4 10"/></svg>';

    figureEl.appendChild(arrowLeft);
    figureEl.appendChild(arrowRight);
    figureEl.classList.add('pcs-has-arrows');

    function updateArrows() {
      arrowLeft.style.display = currentIndex === 0 ? 'none' : '';
      arrowRight.style.display = currentIndex >= slides.length - 1 ? 'none' : '';
    }
    updateArrows();

    arrowLeft.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(currentIndex - 1);
      updateArrows();
    });
    arrowRight.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(currentIndex + 1);
      updateArrows();
    });

    // Update arrows after touch/mouse swipe too
    var origGoTo = goTo;
    goTo = function (index) {
      origGoTo(index);
      updateArrows();
    };

    // Mobile: briefly show arrows on viewport enter
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice) {
      figureEl.classList.add('pcs-touch');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              preloadSlide(slides, 1);
              figureEl.classList.add('pcs-arrows-hint');
              setTimeout(function () {
                figureEl.classList.remove('pcs-arrows-hint');
              }, 2000);
              io.disconnect();
            }
          });
        }, { rootMargin: '200px' });
        io.observe(wrap);
      }
    } else {
      // Desktop: preload slide 2 on viewport enter
      if ('IntersectionObserver' in window) {
        var io2 = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              preloadSlide(slides, 1);
              io2.disconnect();
            }
          });
        }, { rootMargin: '200px' });
        io2.observe(wrap);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pcs-wrap]').forEach(initSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Swatch collapse: "+N" toggle
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-swatch-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var container = btn.closest('[data-swatch-collapse]');
    if (container) {
      container.classList.add('is-expanded');
      // Remove inline display:none from hidden extras
      container.querySelectorAll('.swatch-collapse__extra').forEach(function (el) {
        el.style.display = '';
      });
    }
  });

  // Reviews: customize Judge.me widget text + write trigger
  function customizeReviewsWidget() {
    var accordion = document.querySelector('.reviews-accordion');
    if (!accordion) return;

    // Find "no reviews" text using broad selector
    var noRevText = accordion.querySelector('[class*="jdgm-rev-widg__no-rev"] span, [class*="jdgm-rev-widg__no-rev-text"], [class*="jdgm-rev-widg__no-reviews"] span');
    if (noRevText) {
      noRevText.textContent = 'İlk değerlendirmeyi yapan siz olun';
    }

    // "Değerlendirme yazın" button — trigger Judge.me form
    var writeBtn = accordion.querySelector('[data-reviews-write]');
    if (writeBtn && !writeBtn._bound) {
      writeBtn._bound = true;
      writeBtn.addEventListener('click', function () {
        // Try multiple selectors for Judge.me v3 write link
        var jdgmLink = accordion.querySelector('[class*="jdgm-write-rev"], [class*="jdgm-btn"][href*="review"], a[class*="jdgm"][href="#"]');
        if (jdgmLink) {
          jdgmLink.style.display = 'inline';
          jdgmLink.click();
        }
        // Show form wrapper
        var jdgmForm = accordion.querySelector('[class*="jdgm-form"]');
        if (jdgmForm) {
          jdgmForm.style.display = 'block';
          writeBtn.style.display = 'none';
        }
      });
    }

    // Check if Judge.me fully loaded
    var jdgmLoaded = accordion.querySelector('[class*="jdgm-rev-widg"], [class*="jdgm-widget"]');
    if (!jdgmLoaded) {
      setTimeout(customizeReviewsWidget, 2000);
    }
  }

  // Run after Judge.me loads (it's async)
  setTimeout(customizeReviewsWidget, 1500);
  setTimeout(customizeReviewsWidget, 4000);
  setTimeout(customizeReviewsWidget, 7000);

  // ─── Inline size picker — Massimo Dutti style ──────────────────────
  (function () {
    var SIZE_LABELS = ['beden', 'boyut', 'size'];
    var LOW_STOCK_THRESHOLD = 5;
    var sizeExplicitlyChosen = false;
    var sizePanel = null;
    var pendingForm = null;

    function getSizeFieldset() {
      var fieldsets = document.querySelectorAll('.variant-picker__option');
      for (var i = 0; i < fieldsets.length; i++) {
        var legend = fieldsets[i].querySelector('legend');
        if (legend && SIZE_LABELS.indexOf(legend.textContent.trim().toLowerCase()) > -1) {
          return fieldsets[i];
        }
      }
      return null;
    }

    // Read inventory data from Liquid-generated JSON
    function getInventoryData() {
      try {
        var el = document.querySelector('variant-picker script[data-inventory]');
        if (el) return JSON.parse(el.textContent);
      } catch (e) {}
      return [];
    }

    // Find inventory for a given size label
    function findVariantInventory(inventory, sizeLabel) {
      for (var i = 0; i < inventory.length; i++) {
        var v = inventory[i];
        if (v.option1 === sizeLabel || v.option2 === sizeLabel || v.option3 === sizeLabel) {
          return v;
        }
      }
      return null;
    }

    function buildPanel(buyButtonsEl) {
      if (sizePanel) return sizePanel;

      var fs = getSizeFieldset();
      if (!fs) return null;

      var options = fs.querySelectorAll('.variant-picker__option-values .block-swatch');
      if (!options.length) return null;

      var inventory = getInventoryData();

      // Create inline panel
      sizePanel = document.createElement('div');
      sizePanel.className = 'size-inline-panel';

      // Title
      var titleRow = document.createElement('div');
      titleRow.className = 'size-inline-panel__title';
      titleRow.textContent = 'BEDEN SEÇİNİZ';
      sizePanel.appendChild(titleRow);

      // Size list (vertical)
      var list = document.createElement('div');
      list.className = 'size-inline-panel__list';

      options.forEach(function (opt) {
        var inputId = opt.getAttribute('for');
        var input = inputId ? document.getElementById(inputId) : null;
        var text = opt.textContent.trim();
        if (!input) return;

        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'size-inline-panel__row';

        var soldOut = opt.classList.contains('is-disabled') || opt.hasAttribute('disabled');
        var variantInv = findVariantInventory(inventory, text);
        var lowStock = false;

        if (variantInv) {
          if (!variantInv.available) soldOut = true;
          if (variantInv.available && variantInv.inventory_quantity > 0 && variantInv.inventory_quantity <= LOW_STOCK_THRESHOLD) {
            lowStock = true;
          }
        }

        // Size name
        var nameEl = document.createElement('span');
        nameEl.className = 'size-inline-panel__name';
        nameEl.textContent = text;
        row.appendChild(nameEl);

        // Stock badge
        if (soldOut) {
          row.classList.add('size-inline-panel__row--sold-out');
          row.disabled = true;
          var badge = document.createElement('span');
          badge.className = 'size-inline-panel__badge size-inline-panel__badge--sold-out';
          badge.textContent = 'Tükendi';
          row.appendChild(badge);
        } else if (lowStock) {
          var badge2 = document.createElement('span');
          badge2.className = 'size-inline-panel__badge size-inline-panel__badge--low';
          badge2.textContent = 'Tükenmek üzere';
          row.appendChild(badge2);
        }

        row.addEventListener('click', function () {
          opt.click();
          sizeExplicitlyChosen = true;

          list.querySelectorAll('.size-inline-panel__row').forEach(function (r) {
            r.classList.remove('is-selected');
          });
          row.classList.add('is-selected');

          // Beden seçildi — paneli kapat, tema'nın kendi submit'ini tetikle
          setTimeout(function () {
            closePanel();
            if (pendingForm) {
              var savedForm = pendingForm;
              pendingForm = null;
              // Tema'nın submit handler'ını çalıştırmak için butona tıkla
              setTimeout(function () {
                var submitBtn = savedForm.querySelector('[type="submit"]');
                if (submitBtn) {
                  submitBtn.click();
                }
              }, 100);
            }
          }, 400);
        });

        list.appendChild(row);
      });

      sizePanel.appendChild(list);

      // Footer: model info + size guide
      var footer = document.createElement('div');
      footer.className = 'size-inline-panel__footer';
      footer.innerHTML = '<span class="size-inline-panel__model">Model 178cm · S beden giyiyor</span>' +
        '<button type="button" class="size-inline-panel__guide">Beden Kılavuzu</button>';
      footer.querySelector('.size-inline-panel__guide').addEventListener('click', function () {
        var trigger = document.querySelector('.size-guide-trigger');
        if (trigger) trigger.click();
      });
      sizePanel.appendChild(footer);

      // Insert right before the buy-buttons element
      buyButtonsEl.parentNode.insertBefore(sizePanel, buyButtonsEl);
      return sizePanel;
    }

    function openPanel(buyButtonsEl) {
      var p = buildPanel(buyButtonsEl);
      if (!p) return;
      p.style.display = 'block';
      p.offsetHeight;
      requestAnimationFrame(function () {
        p.classList.add('is-open');
        // Scroll panel into view (for sticky bar clicks)
        setTimeout(function () {
          p.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      });
    }

    function closePanel() {
      if (!sizePanel) return;
      sizePanel.classList.remove('is-open');
      setTimeout(function () {
        sizePanel.style.display = 'none';
      }, 300);
    }

    // On page load: hide original size fieldset + deselect
    function deselectSizeOnLoad() {
      var fs = getSizeFieldset();
      if (!fs) return;
      // Hide original size fieldset — inline panel replaces it
      fs.classList.add('is-hidden-by-panel');
      // Deselect pre-selected size
      var checkedInput = fs.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        var label = checkedInput.nextElementSibling;
        if (label && label.classList.contains('block-swatch')) {
          label.classList.remove('is-selected');
        }
      }
    }

    // Listen for explicit size clicks on main page
    document.addEventListener('click', function (e) {
      if (e.target.closest('.size-inline-panel')) return;
      var optionVal = e.target.closest('.variant-picker__option-values .block-swatch');
      if (!optionVal) return;
      var fieldset = optionVal.closest('.variant-picker__option');
      if (!fieldset) return;
      var legend = fieldset.querySelector('legend');
      if (legend && SIZE_LABELS.indexOf(legend.textContent.trim().toLowerCase()) > -1) {
        sizeExplicitlyChosen = true;
        closePanel();
      }
    });

    // Intercept Add to Cart
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]') && !form.closest('product-form')) return;

      var productInfo = form.closest('.product-info, [class*="main-product"]');
      if (!productInfo) return;

      var fs = getSizeFieldset();
      if (!fs) return;
      if (sizeExplicitlyChosen) return;

      e.preventDefault();
      e.stopPropagation();
      pendingForm = form;

      var buyButtons = form.closest('buy-buttons') || form.closest('.buy-buttons') || form.parentNode;
      openPanel(buyButtons);
    }, true);

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    // Init
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', deselectSizeOnLoad);
    } else {
      deselectSizeOnLoad();
    }
  })();

  // Re-init after infinite scroll / filter updates
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-pcs-wrap]')) initSwipe(node);
        if (node.querySelectorAll) node.querySelectorAll('[data-pcs-wrap]').forEach(initSwipe);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });


})();
